import axios from "axios";

export const urlHelper = {
    openURL,
};

function openURL(url) {
    window.open(url);
}